import {
  ConsultaSeguimentoPergunta14Model,
  ConsultaSeguimentoPergunta14OlhaSeusOlhosEnum,
} from '@atendimento/detail/soap/objetivo/puericultura/mchat-rf/consulta-seguimento/perguntas/consulta-seguimento-pergunta-14/model-consultaSeguimentoPergunta14'
import { MchatRfAplicacaoQueryModel } from '@atendimento/detail/soap/objetivo/puericultura/mchat-rf/model-mChatRf'
import { booleanToSimNaoEnum } from 'components/form'
import { MChatPerguntaEnum } from 'graphql/types.generated'

import { HISTORICO_MCHAT_CALCULATION_STATUS } from '../utils-HistoricoMchatRf'

interface HistoricoMChatRfPergunta14Model {
  header: MchatRfAplicacaoQueryModel
  deuExemploAbaixo: MchatRfAplicacaoQueryModel | undefined
  olhaSeusOlhos: MchatRfAplicacaoQueryModel[]
  olhaSeusOlhosTodosDias: MchatRfAplicacaoQueryModel | undefined
  olhaSeusOlhos5Vezes: MchatRfAplicacaoQueryModel | undefined
  model: ConsultaSeguimentoPergunta14Model
}

export const convertAplicacaoPergunta14 = (
  aplicacoes: ReadonlyArray<MchatRfAplicacaoQueryModel>
): HistoricoMChatRfPergunta14Model | null => {
  const header = aplicacoes.find((aplicacao) => aplicacao.pergunta === MChatPerguntaEnum.PERGUNTA_14_01)
  const deuExemploAbaixo = aplicacoes.find((aplicacao) => aplicacao.pergunta === MChatPerguntaEnum.PERGUNTA_14_02)
  const olhaSeusOlhos = aplicacoes.filter((aplicacao) => PERGUNTA_14_OLHA_SEUS_OLHOS.includes(aplicacao.pergunta))
  const olhaSeusOlhosTodosDias = aplicacoes.find((aplicacao) => aplicacao.pergunta === MChatPerguntaEnum.PERGUNTA_14_09)
  const olhaSeusOlhos5Vezes = aplicacoes.find((aplicacao) => aplicacao.pergunta === MChatPerguntaEnum.PERGUNTA_14_10)

  if (header === undefined) return null

  return {
    header,
    deuExemploAbaixo,
    olhaSeusOlhos,
    olhaSeusOlhosTodosDias,
    olhaSeusOlhos5Vezes,
    model: {
      status: HISTORICO_MCHAT_CALCULATION_STATUS,
      PERGUNTA_14_HEADER: booleanToSimNaoEnum(header.stPassou),
      PERGUNTA_14_DEU_EXEMPLO_ABAIXO: booleanToSimNaoEnum(deuExemploAbaixo?.stPassou),
      PERGUNTA_14_OLHA_SEUS_OLHOS: convertAplicacoesToOlhaSeusOlhos(olhaSeusOlhos),
      PERGUNTA_14_OLHA_SEUS_OLHOS_TODOS_DIAS: booleanToSimNaoEnum(olhaSeusOlhosTodosDias?.stPassou),
      PERGUNTA_14_OLHA_SEUS_OLHOS_5_VEZES: booleanToSimNaoEnum(olhaSeusOlhos5Vezes?.stPassou),
    },
  }
}

const convertAplicacoesToOlhaSeusOlhos = (
  aplicacoes: ReadonlyArray<MchatRfAplicacaoQueryModel>
): Record<ConsultaSeguimentoPergunta14OlhaSeusOlhosEnum, ReturnType<typeof booleanToSimNaoEnum>> =>
  aplicacoes.reduce<Record<ConsultaSeguimentoPergunta14OlhaSeusOlhosEnum, ReturnType<typeof booleanToSimNaoEnum>>>(
    (acc, aplicacao) => {
      const pergunta = MAP_PERGUNTA_TO_ENUM[aplicacao.pergunta]

      if (pergunta) {
        acc[pergunta] = booleanToSimNaoEnum(aplicacao.stPassou)
      }

      return acc
    },
    { ...EMPTY_OLHA_SEUS_OLHOS }
  )

const PERGUNTA_14_OLHA_SEUS_OLHOS = [
  MChatPerguntaEnum.PERGUNTA_14_03,
  MChatPerguntaEnum.PERGUNTA_14_04,
  MChatPerguntaEnum.PERGUNTA_14_05,
  MChatPerguntaEnum.PERGUNTA_14_06,
  MChatPerguntaEnum.PERGUNTA_14_07,
  MChatPerguntaEnum.PERGUNTA_14_08,
]

const EMPTY_OLHA_SEUS_OLHOS: Record<ConsultaSeguimentoPergunta14OlhaSeusOlhosEnum, undefined> = {
  [ConsultaSeguimentoPergunta14OlhaSeusOlhosEnum.PRECISA_DE_ALGUMA_COISA]: undefined,
  [ConsultaSeguimentoPergunta14OlhaSeusOlhosEnum.BRINCANDO]: undefined,
  [ConsultaSeguimentoPergunta14OlhaSeusOlhosEnum.ALIMENTACAO]: undefined,
  [ConsultaSeguimentoPergunta14OlhaSeusOlhosEnum.TROCA_FRALDAS]: undefined,
  [ConsultaSeguimentoPergunta14OlhaSeusOlhosEnum.LENDO_HISTORIA]: undefined,
  [ConsultaSeguimentoPergunta14OlhaSeusOlhosEnum.FALANDO]: undefined,
}

const MAP_PERGUNTA_TO_ENUM: Partial<Record<MChatPerguntaEnum, ConsultaSeguimentoPergunta14OlhaSeusOlhosEnum>> = {
  [MChatPerguntaEnum.PERGUNTA_14_03]: ConsultaSeguimentoPergunta14OlhaSeusOlhosEnum.PRECISA_DE_ALGUMA_COISA,
  [MChatPerguntaEnum.PERGUNTA_14_04]: ConsultaSeguimentoPergunta14OlhaSeusOlhosEnum.BRINCANDO,
  [MChatPerguntaEnum.PERGUNTA_14_05]: ConsultaSeguimentoPergunta14OlhaSeusOlhosEnum.ALIMENTACAO,
  [MChatPerguntaEnum.PERGUNTA_14_06]: ConsultaSeguimentoPergunta14OlhaSeusOlhosEnum.TROCA_FRALDAS,
  [MChatPerguntaEnum.PERGUNTA_14_07]: ConsultaSeguimentoPergunta14OlhaSeusOlhosEnum.LENDO_HISTORIA,
  [MChatPerguntaEnum.PERGUNTA_14_08]: ConsultaSeguimentoPergunta14OlhaSeusOlhosEnum.FALANDO,
}
